import * as React from 'react';
import { BlockLayoutA } from './BlockLayoutA';
import { BlockLayoutB } from './BlockLayoutB';
import { BlockLayoutC } from './BlockLayoutC';
import { BlockLayoutD } from './BlockLayoutD';
import { BlockLayoutE } from './BlockLayoutE';
import { BlockLayoutF } from './BlockLayoutF';
import { BlockLayoutG } from './BlockLayoutG';
import { BlockLayoutH } from './BlockLayoutH';
var layoutComponents = {
  a: BlockLayoutA,
  b: BlockLayoutB,
  c: BlockLayoutC,
  d: BlockLayoutD,
  e: BlockLayoutE,
  f: BlockLayoutF,
  g: BlockLayoutG,
  h: BlockLayoutH
};
export var BlockLayout = function BlockLayout(_ref) {
  var layout = _ref.layout,
      items = _ref.items;
  var LayoutComponent = layoutComponents[layout];
  return React.createElement(LayoutComponent, {
    items: items
  });
};